"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var expect_1 = __importDefault(require("expect"));
exports["default"] = (function (a, b, msg) {
    try {
        // using expect for a nice diff log
        (0, expect_1["default"])(a).toEqual(b);
    }
    catch (e) {
        console.warn(msg + " " + e.message);
    }
});
//# sourceMappingURL=consoleWarnExpectToEqual.js.map